import React from 'react';
import { Button, LinearProgress, Typography } from '@mui/material';
import FilePicker from './FilePicker';

const UploadView = ({
  header = null,
  onFormSubmit,
  selectedFileName,
  onFileSelection,
  isLoading,
  showUploadButton,
  subHeader = null,
  errorMsg = '',
  uploadDisabled = false,
}) => (
  <div className="UploadView">
    <div>{header && <div>{header}</div>}</div>
    <br />
    <div>{subHeader && <div>{subHeader}</div>}</div>
    <form>
      <br />
      <FilePicker
        disabled={uploadDisabled}
        selectedFileName={selectedFileName}
        onFileSelection={onFileSelection}
      />
      <br />
      {isLoading && (
        <div>
          <LinearProgress color="secondary" />
        </div>
      )}
      {!isLoading && showUploadButton && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ verticalAlign: 'middle' }}
            onClick={onFormSubmit}
          >
            Upload
          </Button>
        </div>
      )}
      <br />
      {errorMsg && (
        <div className="UploadView-error">
          <Typography color="error">{errorMsg}</Typography>
        </div>
      )}
    </form>
  </div>
);

export default UploadView;
